import set from 'lodash/set';

import {isObject} from '~ui/utils';

import {ProxyCounter} from './proxy-counter';
import {CounterConfig, Counters} from './types';

export function createCounters(configs: CounterConfig[]) {
    ProxyCounter.createCounters(configs);
}

export const metrika = new ProxyCounter(Counters.Main);
export const crossMetrika = new ProxyCounter(Counters.Cross);

export function initCounter(name: keyof typeof Counters, id: number) {
    ProxyCounter.createCounters([
        {
            name: Counters[name],
            id,
        },
    ]);
}

export function sendParams(params: Record<string, unknown>): void;
export function sendParams(...params: [string, string, ...string[]]): void;
export function sendParams(firstParam: Record<string, unknown> | string, ...params: string[]) {
    const metrikaObject = window.yaCounter || metrika;
    if (isObject(firstParam)) {
        metrikaObject.params(firstParam);
        return;
    }

    const lastParam = params.pop();
    const path = [firstParam, ...params];

    const paramsObject = set({}, path, lastParam);

    metrikaObject.params(paramsObject);
}

export function reachGoal(name: string, params?: Record<string, unknown>) {
    const metrikaObject = window.yaCounter || metrika;

    if (metrikaObject) {
        metrikaObject.reachGoal(name, params);
    }
}

export function crossReachGoal(name: string, params?: Record<string, unknown>) {
    const metrikaObject = window.yaCrossCounter || crossMetrika;

    if (metrikaObject) {
        metrikaObject.reachGoal(name, params);
    }
}

// `ui-core` doesn't support init params
// therefore we must call this function ourselves
// to send initial parameters
export function sendDataUIParam() {
    // explicitly set to `true`, this code function
    // must not be called in the old interface
    sendParams({data_ui_web: true});
}
